import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';

/**
 * View update after an asynchronous answer. The specific windows can sit in a view the application tick does not
 * refresh (results only appeared on the next click), so the view is checked here, once per microtask, never inside a
 * running change detection, never after destroy. Call from an injection context.
 */
export function viewRefresher(): () => void {
  const cd = inject(ChangeDetectorRef);
  let destroyed = false;
  let queued = false;
  inject(DestroyRef).onDestroy(() => (destroyed = true));
  return () => {
    if (destroyed) return;
    cd.markForCheck();
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      if (!destroyed) cd.detectChanges();
    });
  };
}
